import { AllowedCallTypes, CrudConfig } from "seneca-common/utils/apiStates";

export const PATH_TO_STUDENT_ASSIGNMENTS_STATE = "studentAssignments";

export const ACTION_TYPE_ROOT = "seneca/assignments/student/";

export const META_ACTION_TYPE_ROOT = `${ACTION_TYPE_ROOT}meta`;

export const allAssignmentsStateConfig: CrudConfig = {
  name: "past-student-assignments",
  path: META_ACTION_TYPE_ROOT,
  idFieldName: "assignmentId",
  callTypes: [AllowedCallTypes.FETCH_ALL, AllowedCallTypes.FETCH]
};

export const currentAssignmentsStateConfig: CrudConfig = {
  name: "future-student-assignments",
  path: META_ACTION_TYPE_ROOT,
  callTypes: [AllowedCallTypes.FETCH_ALL]
};

export const childAssignmentsStateConfig: CrudConfig = {
  name: "child-assignments",
  path: META_ACTION_TYPE_ROOT,
  idFieldName: "userId",
  callTypes: [AllowedCallTypes.FETCH]
};

export const childAssignmentStateConfig: CrudConfig = {
  name: "child-assignment",
  path: META_ACTION_TYPE_ROOT,
  idFieldName: "assignmentId",
  callTypes: [AllowedCallTypes.FETCH]
};
